/**
 * The two statements the customer must accept. Both are required — the server refuses otherwise.
 * The wording comes from the server, pinned to the version in force when the link was sent.
 */

import { Checkbox } from '@design-system';

interface AgentEnteredConsentStepProps {
  permissionText: string;
  acknowledgementText: string;
  acceptedPermission: boolean;
  acceptedAcknowledgement: boolean;
  disabled?: boolean;
  onAcceptPermission: (accepted: boolean) => void;
  onAcceptAcknowledgement: (accepted: boolean) => void;
}

interface ConsentCheckboxProps {
  id: string;
  text: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

function ConsentCheckbox({ id, text, checked, disabled, onChange }: ConsentCheckboxProps) {
  return (
    <div className="flex items-start gap-3">
      <Checkbox
        id={id}
        className="mt-0.5"
        disabled={disabled}
        checked={checked}
        onCheckedChange={next => onChange(next === true)}
      />
      <label
        htmlFor={id}
        className="text-foreground cursor-pointer text-sm leading-relaxed"
      >
        {text}
      </label>
    </div>
  );
}

export function AgentEnteredConsentStep({
  permissionText,
  acknowledgementText,
  acceptedPermission,
  acceptedAcknowledgement,
  disabled,
  onAcceptPermission,
  onAcceptAcknowledgement,
}: AgentEnteredConsentStepProps) {
  return (
    <div className="space-y-4">
      <ConsentCheckbox
        id="agent-entered-consent-permission"
        text={permissionText}
        checked={acceptedPermission}
        disabled={disabled}
        onChange={onAcceptPermission}
      />
      <ConsentCheckbox
        id="agent-entered-consent-acknowledgement"
        text={acknowledgementText}
        checked={acceptedAcknowledgement}
        disabled={disabled}
        onChange={onAcceptAcknowledgement}
      />
    </div>
  );
}
